<template>
<div class="indexPage" style="height: 100%;overflow-x: hidden;">

    <headfix></headfix>
    <div class="common-banner">
        <div class="bg-img" v-for="(item,index) in advList">
           <img :src="item.advImages" class="pc" @click="goAdv_(item)"/>
           <img :src="item.advSmallImages1" class="mobile" @click="goAdv_(item)"/>
       </div>
    </div>

    <div class="wraper-box" style="position: relative;">
        <div class="cate-title pro">
            <div class="cate-title-top">{{categoryInfo.categoryName}}</div>
            <div class="cate-title-bottom"><span class="t1">{{categoryInfo.code}}</span><span class="t2">{{categoryInfo.categoryTitle}}</span></div>
        </div>

       <div class="case-list">
           <ul>
               <li v-for="(item,index) in videoList">
                   <a href="javascript:;">
                       <div class="case-top">
                           <div class="case-top-left" @click="handleOpen(item)"><img :src="item.thumb"></div>
                           <div class="case-top-right">
                               <div class="rm"><img :src="item.smallThumb"></div>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                       <div class="case-bottom">
                           <div class="lt">
                               <div class="username">{{item.buyUrl}}</div>
                               <div class="address">安装地址：{{item.keywords}}</div>
                           </div>
                           <div class="rt">{{item.description}}</div>
                       </div>
                   </a>
               </li>

           </ul>
           <div class="clearfix"></div>
       </div>


        <div :class="showClass">
           <div class="fix-video-bg"></div>
           <div class="fix-video-close" @click="handleClose"></div>
           <div class="fix-video" v-if="src">
               <playervideo :volume="volume" ref="video" :src="src"></playervideo>
           </div>
       </div>

    </div>
    <footerfix></footerfix>



</div>
</template>
<script>
import headfix from '@/components/utils/headfix';
import footerfix from '@/components/utils/footerfix';
import playervideo from '@/components/utils/playervideo';
import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'
export default {
    components:{headfix, footerfix, playervideo},
    data(){
        return{
            showClass:'hidden',
            volume: 0.5,
            src: "",
            categoryInfo:{},
            categoryList:[],
            videoList:[],
            advList:[],
            tabIndex:-1,
            currentId:0,
        }
    },
    mounted() {
       document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
    },
    created() {
        this.currentId = this.$route.query.cateId;
        this.$nextTick(()=>{
            this.getCategoryData(this.currentId);
            if (this.currentId == 45) {
               this.getAdvData(61);
            }
            this.getVideoListData(this.currentId);
        })
    },
    methods : {
        goCate_,
        goAdv_,
       handleOpen(item) {
           this.src = item.fileUrl;
           this.showClass = 'on';
           this.$refs.video.play();
       },
       handleClose() {
           this.src = "";
           this.showClass = 'hidden';
           this.$refs.video.stop();
       },
      // 分类详情
      getCategoryData (categoryId) {
          this.$post_('api/cms-category/info', {id: categoryId}, (res) => {
              if (res.code == 1) {
                  this.categoryInfo = res.data;
              } else {
                  this.$message.error(res.message);
              }
          })
      },
      // 分类广告
      getAdvData (positionId) {
          this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
              if (res.code == 1) {
                  this.advList = res.data;
              } else {
                  this.$message.error(res.message);
              }
          })
      },
      // 视频列表
      getVideoListData (categoryId) {
            let data = {
                model_id:5,
                categoryId:categoryId
            }
            this.$post_('api/cms-article/article-page', {page:1,size:40, data:data}, (res) => {
                if (res.code == 1) {
                    this.videoList = res.data.records;
                } else {
                    this.$message.error(res.message);
                }
            })
       }
    }
}
</script>

<style scoped>

.hidden{display: none;}
.on{display: block;}
.fix-video-bg{position: fixed;left: 0;top: 0;right: 0;bottom: 0;background: rgba(0,0,0,0.5);z-index: 60;}
.fix-video-close{position: fixed;width: 60px;height: 60px;top: 50px;right: 50px;cursor: pointer;transition: all 500ms ease;z-index: 62;cursor: pointer;}
.fix-video-close:before,.fix-video-close:after{content: '';width: 60px;height: 2px;background: #fff;position: absolute;top: 30px;}
.fix-video-close:before{left: 0;transform: rotate(45deg);}
.fix-video-close:after{left: 0;transform: rotate(135deg);}
.fix-video{position: fixed;top: 50%;left: 50%;max-height: 50vw;max-width: 50vw;transform: translate(-50%, -50%);z-index: 75;width: 600px;height: 450px;}



.case-list{box-sizing:border-box;margin: 0 -15px;padding-bottom: 10px;margin-top: 50px;}
.case-list ul{}
.case-list li{width: 100%;box-sizing:border-box;margin-bottom: 220px;}
.case-list li:last-child{margin-bottom: 140px;}
.case-list li a{display: block;background: #FFFFFF;box-shadow: 0 2px 13px -5px #CCCCCC;cursor: auto;}
.case-top{height: 380px;width: 100%;display: flex;justify-content: flex-start;}
.case-top-left{width: 560px;height: 100%;position: relative;cursor: pointer;}
.case-top-left:before{content: "";background: url(../../assets/img/video1.png) no-repeat center center;height: 68px;width: 68px;margin-top: -34px;margin-left: -34px;position: absolute;left: 50%;top: 50%;z-index: 1;}
.case-top-left:after{content: "";background: url(../../assets/img/video2.png) no-repeat center center;height: 68px;width: 68px;margin-top: -34px;margin-left: -34px;position: absolute;left: 50%;top: 50%;z-index: 1;}



.case-top-left img{width: 100%;height: 100%;object-fit: cover;}
.case-top-right{height: 100%;box-shadow: 0 2px 13px -5px #CCCCCC;flex: 1;position: relative;}
.rm{position: absolute;top:-100px;height: 480px;width: 100%;}

.case-top-right img{width: 100%;height: 100%;object-fit: cover;}
.bottom{color: #333333;margin-top: 0px;}
.case-bottom{display: flex;height: 150px;overflow: hidden;align-items: center;}
.case-bottom .lt{width: 562px;margin-top: -5px;}
.username{font-size: 44px;font-weight: bold;margin-bottom: 5px;margin-left: 50px;margin-right: 20px;}
.address{font-size: 16px;color: #444444;margin-left: 50px;margin-right: 20px;}
.case-bottom .rt{font-size: 12px;flex: 1;color: #666666;margin-right: 30px;height: 80px;overflow: hidden;display: flex;align-items: center;}

.vjs_video_3-dimensions{width: 100%;height: 100%;}

/*产品中心-筛选*/

@media (max-width:1799px){
    .case-top{height: 400px;}
   .rm{height: 480px;top: -80px;}
   .case-top-left{width: 500px;}
   .case-bottom .lt{width: 500px;}
}
@media (max-width:1199px){
    .case-top{height: 350px;}
    .rm{height: 400px;top: -50px;}
    .case-top-left{width: 400px;}
    .case-bottom .lt{width: 402px;}
}
@media (max-width:993px){
    .case-top{height: 300px;}
    .rm{height: 380px;top: -80px;}
    .case-top-left{width: 350px;}
    .case-bottom{height: 100px;}
    .case-bottom .lt{width: 352px;margin-top: 0px;}
    .username{font-size: 24px;margin-left: 10px;}
    .address{font-size: 14px;margin-left: 10px;}
}

@media (max-width:767px){
    .case-list{margin-top: 30px;}
    .case-list li{width: 100%;box-sizing:border-box;margin-bottom: 50px;}
    .case-list li:last-child{margin-bottom: 30px;}
    .case-list li a{margin: 0px 30px;}
    .case-top-left{width: 100%;}
    .case-bottom .rt{display: none;}
}


</style>
